<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useWebSocketStore } from '@/stores/websocket'

const authStore = useAuthStore()
const wsStore = useWebSocketStore()

onMounted(async () => {
  // Check if user is authenticated on app mount
  await authStore.checkAuth()
  
  // Connect WebSocket if authenticated (only if not already connected)
  if (authStore.isAuthenticated && !wsStore.isConnected) {
    wsStore.connect()
  }
})

// Watch for auth state changes and connect/disconnect accordingly
watch(() => authStore.isAuthenticated, (isAuthenticated) => {
  if (isAuthenticated && !wsStore.isConnected) {
    // User logged in, connect WebSocket
    wsStore.connect()
  } else if (!isAuthenticated && wsStore.isConnected) {
    // User logged out, disconnect WebSocket
    wsStore.disconnect()
  }
})
</script>
